$(function() {

	/*
	 * Fire the animation on the table to indicate it is scrollable when in view.
	 */

	 // isFullyInViewport function
	$.fn.isFullyInViewport = function() {
	    var elementTop = $(this).offset().top;
	    var elementBottom = elementTop + $(this).outerHeight();
	    var viewportTop = $(window).scrollTop();
	    var viewportBottom = viewportTop + $(window).height();
	    return elementTop >= viewportTop && elementBottom <= viewportBottom;
	};

	function animateTables() {
		var tableSelector = $('.table-selector');

	    $(tableSelector).each(function() {
	        if ($(this).isFullyInViewport()) {
	          $(this).addClass('animate-table');
	          setTimeout(function(){
	            $(tableSelector).removeClass('animate-table');
	          }, 1000);
	        }
	    });
	}

	// Resize and scroll event binding
	$(window).on('resize scroll', function() {
	    var oshTableWidth = $('.table-selector').outerWidth();
	    var tableWrapperWidth = $('.responsive-table-wrapper').outerWidth();

	    if (oshTableWidth > tableWrapperWidth){
	        animateTables();
	    }
	});

});

//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlcyI6WyJhbmltYXRlLW92ZXJmbG93LmpzIl0sImZpbGUiOiJhbmltYXRlLW92ZXJmbG93LmpzIn0=
